module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Weather/Sun-3951b8f558ff248271e233ddb7d11dd3b21cb17931960be3c64d4f95be74704e.svg";